module.exports = __webpack_public_path__ + "static/img/zssxl.39c1708.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/zssxl.png
// module id = rK/c
// module chunks = 0